import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/App";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Methodology from "@/components/Methodology";
import About from "@/components/About";
import InquiryForm from "@/components/InquiryForm";
import Footer from "@/components/Footer";
import SeoHead from "@/components/SeoHead";
import FooterScripts from "@/components/FooterScripts";

export default function Landing() {
  const [seo, setSeo] = useState(null);

  useEffect(() => {
    axios.get(`${API}/seo/public`).then((r) => setSeo(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[#0D1729] text-white">
      <SeoHead seo={seo} />
      <Hero seo={seo} />
      <Services />
      <Methodology />
      <About />
      <InquiryForm />
      <Footer />
      <FooterScripts html={seo?.footer_html} />
    </div>
  );
}
